app.service('fileService', ['$q', 'crudService', '$state', '$window', 'modalService', function ($q, crudService, $state, $window, modalService) {
	/**
	 * Vérifie si le fichier exists et retourne une promise
	 * @param type
	 * @param id
	 * @param num
	 * @returns {deferred.promise|{then, catch, finally}}
	 */
	this.exists = function(type, id, num) {
		return crudService.get('/file/'+type+'/'+id+'/'+ num+'/check').then(function(response) {
			if(response) return $q.resolve(response);
			else return $q.reject(response);
		});
	};


	this.goTo = function(type, id, num, stamp) {
		$window.location.href = this.getUrl({
			type: type,
			id: id,
			num: num,
			stamp: stamp
		});
	};

	/**
	 *
	 * @param type
	 * @param id
	 * @param num
	 * @returns {*}
	 */
	this.check = function(type, id, num) {
		var self = this;
		return this.exists(type, id, num).then(function() {
			self.goTo(type, id, num);
		}, function () {
			modalService.file();
		});
	};

	this.getData = function(url) {
		var res = {};
		if (url.lastIndexOf('/') != -1 ) {
			var data = url.split('/');

			res['type'] = data[data.length - 2];

			data = data[data.length - 1].split('_');
			res['stamp'] = data[0];
			res['num'] = data[1].replace('champ','');
			res['id'] = data[2].split('.')[0];
		}

		return res;
	};

	this.getUrl = function(data) {
		return '/file/'+data.type+'/'+data.id+'/'+data.num+'/'+data.stamp+'/get';
	}

	this.getUrlOpen = function(data) {
		return '/file/'+data.type+'/'+data.id+'/'+data.num+'/'+data.stamp+'/open';
	}

	this.getUrlRemove = function(data) {
		return '/file/'+data.type+'/'+data.id+'/'+data.num+'/'+data.stamp+'/remove';
	}



}]);
